import React, {Component, PropTypes} from 'react'
import { Table, Icon, Collapse, Row, Col, Rate } from 'antd'
const Panel = Collapse.Panel
import { getRegularResult, EXTENDED_TRIAL_PERIOD, OUT_OF_PHASE, ADVANCE_AHEAD, NORMAL_TURN_RIGHT } from '../../../../config/regularResult'
import classnames from 'classnames'
class Detail extends Component {
	render () {
    const { data = {} } = this.props
    const { professional = {}, team = {}, quality = {}, post = {}, culture = {}, regularResult } = data
    const { innovation, self_driven, simple, fast } = culture

    const statusType = classnames('icon', {
      warning: regularResult === EXTENDED_TRIAL_PERIOD,
      danger: regularResult === OUT_OF_PHASE,
      info: regularResult === ADVANCE_AHEAD || regularResult === NORMAL_TURN_RIGHT
    })
    
		return (
      <div className="opinionTable-w">
        <Collapse defaultActiveKey={[]}>
          <Panel header="转正意见表：" key="1">
            <div className="header">
              <span className="title">转正评估</span>
              <span className="status">综合建议：<span className={statusType}></span>{getRegularResult(regularResult)}</span>
            </div>
            <div className="wrap">
              <div className="t-wrap">
                <div className='title'>专业能力</div>
                <div className="val-star"><Rate disabled value={professional.val}/><span className="star-num">{professional.val}分</span></div>
                <div className="val-c">{professional.des}</div>
              </div>

              <div className="t-wrap">
                <div className='title'>团队匹配度</div>
                <div className="val-star"><Rate disabled value={team.val}/><span className="star-num">{team.val}分</span></div>
                <div className="val-c">{team.des}</div>
              </div>
              
              <div className="t-wrap">
                <div className='title'>素质与潜力</div>
                <div className="val-star"><Rate disabled value={quality.val}/><span className="star-num">{quality.val}分</span></div>
                <div className="val-c">{quality.des}</div>
              </div>

              <div className="t-wrap">
                <div className='title'>岗位匹配度</div>
                <div className="val-star"><Rate disabled value={post.val}/><span className="star-num">{post.val}分</span></div>
                <div className="val-c">{post.des}</div>
              </div>

              <div className="t-wrap">
                <div className='title'>文化价值观</div>
                <div className="val-star"></div>
                <div className="val-c">
                  <ul className='culture'>
                    <li><span className="sub-t">创新：</span>{innovation}</li>
                    <li><span className="sub-t">自我驱动：</span>{self_driven}</li>
                    <li><span className="sub-t">简单：</span>{simple}</li>
                    <li><span className="sub-t">快速：</span>{fast}</li>
                  </ul>
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
		)
	}
}


export default Detail


// WEBPACK FOOTER //
// ./src/components/workflow/assigneeDetail/regular/opinionTable.js